
(() => {
  if (window.HpCollectionPage) return;

  const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  const initSliders = (scope = document) => {
    if (!window.hpEnableCarouselDragScroll) return;
    scope.querySelectorAll('[data-hp-collection-slider] grid-carousel').forEach((carousel) => {
      window.hpEnableCarouselDragScroll(carousel);
    });
  };

  const getPageFromUrl = (url) => {
    try {
      const page = parseInt(new URL(url, window.location.origin).searchParams.get('page') || '1', 10);
      return Number.isFinite(page) && page > 0 ? page : 1;
    } catch (error) {
      return 1;
    }
  };

  const buildPageUrl = (page) => {
    const url = new URL(window.location.href);
    if (page > 1) url.searchParams.set('page', String(page));
    else url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    return url;
  };

  const getState = (section) => {
    if (!section.__hpCollectionState) {
      const main = section.closest('.hp-collection-main');
      const autoLoadPages = main?.dataset.hpAutoLoadPages || '0';
      section.__hpCollectionState = {
        autoLoaded: 0,

        maxAuto: autoLoadPages === 'all' ? Infinity : parseInt(autoLoadPages, 10) || 0,
        lastRequestedPage: null,

        replacing: false,
        replacingTimer: 0,

        pageJump: false,
        awaitingInput: false,

        restoring: false,
        observer: null,
        observed: null,
        sliderScroll: null,

        below: null,
      };
    }
    return section.__hpCollectionState;
  };

  const setScrollRestoration = (mode) => {
    try {
      window.history.scrollRestoration = mode;
    } catch (error) {}
  };

  const setLoading = (section, mode) => {
    if (mode) section.setAttribute('data-hp-loading', mode);
    else section.removeAttribute('data-hp-loading');
  };

  const clearLoadMoreBusy = (section) => {
    section.querySelectorAll('[data-hp-load-more].is-loading').forEach((link) => {
      link.classList.remove('is-loading');
      link.removeAttribute('aria-busy');
    });
    setLoading(section, null);
  };

  const setReplacing = (section, value) => {
    const state = getState(section);
    window.clearTimeout(state.replacingTimer);
    state.replacing = value;

    if (value) {
      state.replacingTimer = window.setTimeout(() => {
        state.replacing = false;
      }, 8000);
    }
  };

  const requestNextPage = (section, link) => {
    const state = getState(section);

    if (!link || link.classList.contains('is-loading') || state.replacing || state.restoring) return false;

    state.lastRequestedPage = parseInt(link.dataset.page || '0', 10) || getPageFromUrl(link.href);
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');
    const below = readBelowList(section);
    setLoading(section, 'append');
    holdBelowList(section, below);

    link.dispatchEvent(
      new CustomEvent('section:update', {
        bubbles: true,
        detail: { url: link.href, mode: 'append' },
      }),
    );
    return true;
  };

  const disconnectObserver = (state) => {
    state.observer?.disconnect();
    state.observer = null;
    state.observed = null;
  };

  const observeLoadMore = (section) => {
    const state = getState(section);
    const wrapper = section.querySelector('[data-hp-load-more-wrapper]');
    const link = section.querySelector('[data-hp-load-more]');

    if (state.observer && state.observed !== wrapper) disconnectObserver(state);

    if (!wrapper || !link || !('IntersectionObserver' in window)) return;
    if (state.restoring || state.awaitingInput || state.autoLoaded >= state.maxAuto) return;
    if (state.observer) return;

    state.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        const currentLink = section.querySelector('[data-hp-load-more]');
        if (!currentLink || state.autoLoaded >= state.maxAuto) return;
        if (state.replacing || state.restoring) return;
        disconnectObserver(state);
        if (requestNextPage(section, currentLink)) state.autoLoaded += 1;
      },
      {

        rootMargin: state.maxAuto === Infinity ? '100000px 0px 480px 0px' : '0px 0px 480px 0px',
      },
    );
    state.observer.observe(wrapper);
    state.observed = wrapper;
  };

  const anchorsNatively = Boolean(window.CSS?.supports?.('overflow-anchor', 'auto'));

  const belowListAnchor = (section) => {

    const slot = section.querySelector('[data-hp-collection-extras]');
    if (slot && slot.getBoundingClientRect().height > 0) return slot;
    return section.closest('.shopify-section')?.nextElementSibling || null;
  };

  const readBelowList = (section) => {
    if (anchorsNatively) return null;
    const list = section.querySelector('[data-product-list]');
    const anchor = belowListAnchor(section);
    if (!list || !anchor) return null;
    return { anchor, top: anchor.getBoundingClientRect().top, below: list.getBoundingClientRect().bottom < 0 };
  };

  const holdBelowList = (section, before) => {
    const state = getState(section);
    if (before?.below && !state.restoring && before.anchor.isConnected) {
      const diff = before.anchor.getBoundingClientRect().top - before.top;
      if (Math.abs(diff) > 0.5) window.scrollBy(0, diff);
    }
    state.below = readBelowList(section);
  };

  if (!anchorsNatively) {
    let belowFrame = 0;
    window.addEventListener(
      'scroll',
      () => {
        window.cancelAnimationFrame(belowFrame);
        belowFrame = window.requestAnimationFrame(() => {
          document.querySelectorAll('collection-section').forEach((section) => {
            getState(section).below = readBelowList(section);
          });
        });
      },
      { passive: true },
    );
  }

  const waitForInput = (section) => {
    const state = getState(section);
    const inputEvents = ['wheel', 'touchstart', 'keydown'];
    let scrollTimer = 0;

    const resume = () => {
      window.clearTimeout(scrollTimer);
      inputEvents.forEach((type) => window.removeEventListener(type, resume));
      window.removeEventListener('scroll', resume);
      state.awaitingInput = false;
      observeLoadMore(section);
    };

    state.awaitingInput = true;
    inputEvents.forEach((type) => window.addEventListener(type, resume, { passive: true }));

    scrollTimer = window.setTimeout(() => window.addEventListener('scroll', resume, { passive: true }), 1500);
  };

  const RESTORE_KEY = 'hp:plp:restore';
  const RESTORE_MAX_AGE = 30 * 60 * 1000;

  const RESTORE_MAX_PAGES = 5;
  const HEADER_OFFSET = 80;

  const getListKey = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.sort();
    return `${url.pathname}?${url.searchParams.toString()}`;
  };

  const getLoadedPages = (list) =>
    [...list.children].map((item) => parseInt(item.dataset.page || '0', 10)).filter(Boolean);

  const RESTORE_MAX_LISTS = 8;

  const readRecords = () => {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(RESTORE_KEY) || 'null');

      return value && typeof value === 'object' && !Array.isArray(value) && !('key' in value) ? value : {};
    } catch (error) {
      return {};
    }
  };

  const readRecord = () => readRecords()[getListKey()] || null;

  let clickedCard = null;

  const saveListState = () => {
    const list = document.querySelector('collection-section [data-product-list]');
    if (!list) return;

    const pages = getLoadedPages(list);
    if (!pages.length) return;

    const cards = [...list.querySelectorAll('product-card')];
    const anchor =
      (clickedCard && list.contains(clickedCard) && clickedCard) ||
      cards.find((card) => card.getBoundingClientRect().bottom > HEADER_OFFSET) ||
      null;
    const rect = anchor?.getBoundingClientRect();

    try {
      const key = getListKey();
      const records = readRecords();

      delete records[key];
      records[key] = {
        key,
        first: Math.min(...pages),
        last: Math.max(...pages),
        anchorId: anchor?.id || null,
        anchorTop: rect ? Math.round(rect.top) : 0,
        anchorLeft: rect ? Math.round(rect.left) : 0,

        listBottom: Math.round(list.getBoundingClientRect().bottom),

        sections: !hasDeferredSections(),
        width: window.innerWidth,
        time: Date.now(),
      };
      Object.keys(records)
        .slice(0, -RESTORE_MAX_LISTS)
        .forEach((oldKey) => delete records[oldKey]);
      window.sessionStorage.setItem(RESTORE_KEY, JSON.stringify(records));
    } catch (error) {}
  };

  const getRestoreRecord = () => {
    if (window.Shopify?.designMode) return null;

    const navigation = window.performance?.getEntriesByType?.('navigation')[0];
    if (!navigation || (navigation.type !== 'back_forward' && navigation.type !== 'reload')) return null;

    const record = readRecord();
    if (!record || record.key !== getListKey()) return null;
    if (Date.now() - record.time > RESTORE_MAX_AGE) return null;

    const current = getPageFromUrl(window.location.href);
    if (record.last !== current || record.first > current) return null;

    if (record.first === current && window.history.scrollRestoration !== 'manual') return null;

    return record;
  };

  const fetchPageItems = async (section, page) => {
    const shopifySection = section.closest('.shopify-section');
    const url = buildPageUrl(page);
    url.searchParams.set('section_id', shopifySection.id.replace('shopify-section-', ''));

    const response = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const incomingList = doc.querySelector('[data-product-list]');
    return incomingList ? [...incomingList.children] : [];
  };

  const keepInPlace = (measure, top, duration) =>
    new Promise((resolve) => {
      const inputEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'];
      let userInput = false;
      const stop = () => {
        userInput = true;
      };
      inputEvents.forEach((type) => window.addEventListener(type, stop, { passive: true }));

      const until = performance.now() + duration;
      const loop = () => {
        const position = userInput ? null : measure();
        if (position !== null) {
          const diff = position - top;
          if (Math.abs(diff) > 1) window.scrollBy(0, diff);
        }
        if (!userInput && performance.now() < until) {
          window.requestAnimationFrame(loop);
        } else {
          inputEvents.forEach((type) => window.removeEventListener(type, stop));
          resolve();
        }
      };
      loop();
    });

  const restoreList = async (section, sectionsReady = null) => {
    const list = section.querySelector('[data-product-list]');
    const record = list ? getRestoreRecord() : null;
    if (!record) return false;

    const state = getState(section);
    const current = getPageFromUrl(window.location.href);
    const firstPage = Math.max(record.first, current - RESTORE_MAX_PAGES);
    const getAnchor = () => (record.anchorId ? document.getElementById(record.anchorId) : null);

    const hasListBottom = Number.isFinite(record.listBottom);
    const measureAnchor = () => {
      const anchor = getAnchor();
      return anchor ? anchor.getBoundingClientRect().top : null;
    };
    const measureListBottom = () => list.getBoundingClientRect().bottom;
    const settle = (duration, fallbackMeasure, fallbackTop) => {
      if (getAnchor()) return keepInPlace(measureAnchor, record.anchorTop, duration);
      if (hasListBottom) return keepInPlace(measureListBottom, record.listBottom, duration);
      return fallbackMeasure ? keepInPlace(fallbackMeasure, fallbackTop, duration) : Promise.resolve();
    };

    const waitForSections = () =>
      sectionsReady && hasListBottom && !getAnchor() ? Promise.race([sectionsReady, wait(2500)]) : Promise.resolve();

    const waitInputEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'];
    let movedOn = false;
    const markInput = () => {
      movedOn = true;
    };

    let viewRestored = false;

    state.restoring = true;
    setScrollRestoration('manual');

    try {

      const placeholders = [];
      const earlyAnchor = getAnchor();
      if (earlyAnchor) {
        const columns = getComputedStyle(list).gridTemplateColumns.split(' ').length;
        if (firstPage < current && columns > 1 && record.width === window.innerWidth) {
          const lefts = [...list.children].slice(0, columns).map((item) => item.getBoundingClientRect().left);
          const step = lefts.length > 1 ? lefts[1] - lefts[0] : 0;
          if (step > 0) {
            let shift = Math.round((record.anchorLeft - earlyAnchor.getBoundingClientRect().left) / step) % columns;
            if (shift < 0) shift += columns;
            for (let index = 0; index < shift; index += 1) {
              const placeholder = document.createElement('li');
              placeholder.setAttribute('aria-hidden', 'true');
              list.prepend(placeholder);
              placeholders.push(placeholder);
            }
          }
        }
        window.scrollTo(0, window.scrollY + earlyAnchor.getBoundingClientRect().top - record.anchorTop);
        viewRestored = Math.abs(earlyAnchor.getBoundingClientRect().top - record.anchorTop) <= 1;
      } else if (hasListBottom) {
        window.scrollTo(0, window.scrollY + measureListBottom() - record.listBottom);
        viewRestored = Math.abs(measureListBottom() - record.listBottom) <= 1;
      }

      if (firstPage >= current) {
        await waitForSections();

        await settle(1200);
        return true;
      }

      section.setAttribute('data-hp-restoring', '');
      waitInputEvents.forEach((type) => window.addEventListener(type, markInput, { passive: true }));

      const pages = [];
      for (let page = firstPage; page < current; page += 1) pages.push(page);

      let results = [];
      try {
        results = await Promise.all(pages.map((page) => fetchPageItems(section, page)));
      } catch (error) {

        placeholders.forEach((placeholder) => placeholder.remove());
        return true;
      }

      const reference = [...list.children].find((item) => !placeholders.includes(item)) || null;
      const referenceTop = reference ? reference.getBoundingClientRect().top : 0;

      const heldBottom = movedOn && viewRestored ? measureListBottom() : null;

      const fragment = document.createDocumentFragment();
      results.forEach((items) => items.forEach((item) => fragment.appendChild(document.importNode(item, true))));
      placeholders.forEach((placeholder) => placeholder.remove());
      list.prepend(fragment);

      section.removeAttribute('data-hp-restoring');
      await waitForSections();

      if (heldBottom !== null) await keepInPlace(measureListBottom, heldBottom, 1000);
      else await settle(1000, () => (reference ? reference.getBoundingClientRect().top : null), referenceTop);

      return true;
    } finally {
      waitInputEvents.forEach((type) => window.removeEventListener(type, markInput));
      section.removeAttribute('data-hp-restoring');
      state.restoring = false;
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const card = event.target instanceof Element ? event.target.closest('[data-product-list] product-card') : null;
      if (!card) return;
      clickedCard = card;
      saveListState();
    },
    true,
  );

  window.addEventListener('pagehide', saveListState);

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    document.querySelectorAll('collection-section').forEach((section) => {
      const state = getState(section);
      state.lastRequestedPage = null;
      setReplacing(section, false);
      clearLoadMoreBusy(section);
      disconnectObserver(state);
      observeLoadMore(section);
    });

    const record = readRecord();
    const anchor = record?.anchorId ? document.getElementById(record.anchorId) : null;
    if (anchor && record.key === getListKey() && window.history.scrollRestoration === 'manual') {
      const diff = anchor.getBoundingClientRect().top - record.anchorTop;
      if (Math.abs(diff) > 2) window.scrollBy(0, diff);
    }
  });

  let lastSliderClick = null;

  const sliderItemKey = (item) => item.getAttribute('title') || item.getAttribute('href') || '';

  const getSliderItems = (carousel) => [...(carousel?.children || [])].filter((node) => node instanceof HTMLElement);

  const setTrackScroll = (track, left) => {
    const previous = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    track.style.scrollBehavior = previous;
  };

  const saveSliderScroll = (section) => {
    const saved = [];
    const recentClick = lastSliderClick && performance.now() - lastSliderClick.time < 3000 ? lastSliderClick : null;

    section.querySelectorAll('[data-hp-collection-slider]').forEach((root) => {
      const carousel = root.querySelector('grid-carousel');
      const track = carousel?.shadowRoot?.querySelector('#track');
      if (!track || track.scrollWidth <= track.clientWidth) return;

      const trackLeft = track.getBoundingClientRect().left;
      const items = getSliderItems(carousel);
      let anchor = recentClick ? items.find((item) => sliderItemKey(item) === recentClick.key) : null;
      if (!anchor) anchor = items.find((item) => item.getBoundingClientRect().right > trackLeft + 1) || null;

      saved.push({
        id: root.dataset.carouselId,
        scrollLeft: track.scrollLeft,
        key: anchor ? sliderItemKey(anchor) : null,
        offset: anchor ? anchor.getBoundingClientRect().left - trackLeft : 0,
      });
    });

    getState(section).sliderScroll = saved;
  };

  const restoreSliderScroll = async (section) => {
    const state = getState(section);
    const saved = state.sliderScroll;
    state.sliderScroll = null;
    if (!saved || !saved.length) return;

    if (!customElements.get('grid-carousel')) await customElements.whenDefined('grid-carousel');

    await Promise.all(
      saved.map(async (entry) => {
        const root = [...section.querySelectorAll('[data-hp-collection-slider]')].find(
          (node) => node.dataset.carouselId === entry.id,
        );
        const carousel = root?.querySelector('grid-carousel');
        if (!carousel) return;
        if (carousel.updateComplete) await carousel.updateComplete;

        const targetLeft = (track) => {
          let target = entry.scrollLeft;
          const item = entry.key ? getSliderItems(carousel).find((node) => sliderItemKey(node) === entry.key) : null;
          if (item) {
            target = track.scrollLeft + (item.getBoundingClientRect().left - track.getBoundingClientRect().left) - entry.offset;
          }
          return Math.min(Math.max(0, track.scrollWidth - track.clientWidth), Math.max(0, target));
        };

        await new Promise((resolve) => requestAnimationFrame(resolve));
        let track = carousel.shadowRoot?.querySelector('#track');
        if (!track) return;
        const target = targetLeft(track);
        setTrackScroll(track, target);

        for (const delay of [120, 350]) {
          await wait(delay);
          track = carousel.shadowRoot?.querySelector('#track');
          if (track && target > 2 && track.scrollLeft < 2) setTrackScroll(track, targetLeft(track));
        }
      }),
    );
  };

  const setFilterFocus = (modal, accordion) => {
    modal.querySelectorAll('[data-hp-focused]').forEach((item) => {
      if (item !== accordion) item.removeAttribute('data-hp-focused');
    });

    if (!accordion) {
      modal.removeAttribute('data-hp-focus');
      return;
    }

    modal.setAttribute('data-hp-focus', accordion.id);
    accordion.setAttribute('data-hp-focused', '');
    accordion.open = true;
  };

  document.addEventListener('click', (event) => {
    const opener = event.target instanceof Element ? event.target.closest('[data-modal]') : null;
    const modal = opener ? document.getElementById(opener.dataset.modal || '') : null;
    if (!modal || !modal.classList.contains('filters-mobile-modal')) return;

    const accordion = opener.dataset.hpOpenFilter ? document.getElementById(opener.dataset.hpOpenFilter) : null;
    setFilterFocus(modal, accordion && modal.contains(accordion) ? accordion : null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== ' ') return;
    const chip = event.target instanceof Element ? event.target.closest('a.hp-chip[role="button"]') : null;
    if (!chip) return;

    event.preventDefault();
    if (!event.repeat) chip.click();
  });

  const FILTER_HOST = 'smooth-collapse, .hp-chip-panel';

  const foldText = (value) =>
    (value || '')
      .toLocaleLowerCase('tr')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ı/g, 'i')
      .trim();

  const applyFilterSearch = (input) => {
    const wrapper = input.closest('[data-hp-filter-search]');
    const scope = wrapper?.parentElement;
    const list = scope?.querySelector('[data-hp-filter-list]');
    if (!list) return;

    const query = foldText(input.value);
    let visibleCount = 0;

    [...list.children].forEach((item) => {
      const isMatch = !query || foldText(item.dataset.hpFilterLabel || item.textContent).includes(query);
      item.hidden = !isMatch;
      if (isMatch) visibleCount += 1;
    });

    wrapper.closest(FILTER_HOST)?.toggleAttribute('data-hp-searching', Boolean(query));

    const empty = scope.querySelector('[data-hp-filter-empty]');
    if (empty) empty.hidden = visibleCount > 0;
  };

  const reapplyFilterSearch = () => {
    document.querySelectorAll('[data-hp-filter-search] input').forEach(applyFilterSearch);
  };

  document.addEventListener('input', (event) => {
    const input = event.target instanceof Element ? event.target.closest('[data-hp-filter-search] input') : null;
    if (input) applyFilterSearch(input);
  });

  document.addEventListener(
    'change',
    (event) => {
      if (event.target instanceof Element && event.target.closest('[data-hp-filter-search]')) event.stopPropagation();
    },
    true,
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    if (event.target instanceof Element && event.target.closest('[data-hp-filter-search]')) event.preventDefault();
  });

  const SCROLL_ROW = '[data-hp-scroll-row], .hp-filter-strip .active-filters';
  const boundScrollRows = new WeakSet();

  const syncScrollRow = (row) => {
    const max = row.scrollWidth - row.clientWidth;
    let state = null;
    if (max > 1) {
      const left = Math.abs(row.scrollLeft);
      if (left <= 1) state = 'start';
      else if (left >= max - 1) state = 'end';
      else state = 'middle';
    }

    if (state === null) row.removeAttribute('data-hp-scroll');
    else if (row.getAttribute('data-hp-scroll') !== state) row.setAttribute('data-hp-scroll', state);
  };

  const touchedScrollRows = new WeakSet();

  const revealInScrollRow = (row) => {
    const selector = row.dataset.hpScrollReveal;
    if (!selector || touchedScrollRows.has(row)) return;

    const targets = row.querySelectorAll(selector);
    const target = targets[targets.length - 1];
    row.scrollLeft = 0;
    if (!target || row.scrollWidth - row.clientWidth <= 1) return;

    const hidden = target.getBoundingClientRect().right - row.getBoundingClientRect().right;
    if (hidden > -24) row.scrollLeft = hidden + 24;
  };

  const scrollRowObserver =
    'ResizeObserver' in window
      ? new ResizeObserver((entries) =>
          entries.forEach((entry) => {
            revealInScrollRow(entry.target);
            syncScrollRow(entry.target);
          }),
        )
      : null;

  const initScrollRows = (scope = document) => {
    scope.querySelectorAll(SCROLL_ROW).forEach((row) => {
      if (!boundScrollRows.has(row)) {
        boundScrollRows.add(row);
        row.addEventListener('scroll', () => syncScrollRow(row), { passive: true });
        ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((type) =>
          row.addEventListener(type, () => touchedScrollRows.add(row), { passive: true }),
        );
        scrollRowObserver?.observe(row);

        window.hpEnableNativeDragScroll?.(row, { container: row });
        revealInScrollRow(row);
      }
      syncScrollRow(row);
    });
  };

  document.addEventListener('focusin', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !target.matches(':focus-visible')) return;

    let row = target.parentElement?.closest(SCROLL_ROW);
    while (row && row.scrollWidth - row.clientWidth <= 1) row = row.parentElement?.closest(SCROLL_ROW);
    if (row) target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });

  const FIRST_PAGE_ONLY = 'template[data-hp-first-page-only]';
  let firstPageSectionsRequest = null;

  const hasDeferredSections = () => Boolean(document.querySelector(FIRST_PAGE_ONLY));

  const runScripts = (root) => {
    root.querySelectorAll('script').forEach((inert) => {
      const type = (inert.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'module') return;

      const script = document.createElement('script');
      [...inert.attributes].forEach((attribute) => script.setAttribute(attribute.name, attribute.value));
      script.textContent = inert.textContent;
      inert.replaceWith(script);
    });
  };

  const loadFirstPageSections = () => {
    if (firstPageSectionsRequest) return firstPageSectionsRequest;

    const ids = [...document.querySelectorAll(FIRST_PAGE_ONLY)]
      .map((marker) => marker.closest('.shopify-section')?.id.replace('shopify-section-', ''))
      .filter(Boolean);
    if (!ids.length) return Promise.resolve(false);

    const url = buildPageUrl(1);
    url.searchParams.set('sections', ids.slice(0, 5).join(','));

    firstPageSectionsRequest = fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((sections) => {
        ids.forEach((id) => {
          const target = document.getElementById(`shopify-section-${id}`);
          const html = sections?.[id];

          if (!target || typeof html !== 'string' || !target.querySelector(FIRST_PAGE_ONLY)) return;

          const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(`shopify-section-${id}`);
          if (!fresh) return;

          target.innerHTML = fresh.innerHTML;
          runScripts(target);
        });
        return true;
      })
      .catch(() => false)
      .finally(() => {
        firstPageSectionsRequest = null;
      });

    return firstPageSectionsRequest;
  };

  const shouldRestoreSections = () => {
    if (window.Shopify?.designMode || !hasDeferredSections()) return false;

    const navigation = window.performance?.getEntriesByType?.('navigation')[0];
    if (!navigation || navigation.type !== 'back_forward') return false;

    const record = readRecord();
    if (!record || record.key !== getListKey() || !record.sections) return false;
    if (Date.now() - record.time > RESTORE_MAX_AGE) return false;

    return record.last === getPageFromUrl(window.location.href);
  };

  const EXTRA_SECTIONS =
    ':scope > .section-hp-collection-insights, :scope > .section-hp-collection-seo-text, :scope > .section-hp-collection-related-categories, :scope > .section-hp-collection-faq';
  const dockQuery = window.matchMedia('(min-width: 64rem)');

  const syncDockedSections = () => {
    if (window.Shopify?.designMode) return;

    const slot = document.querySelector('[data-hp-collection-extras]');
    const main = document.getElementById('MainContent');
    const gridSection = slot?.closest('.shopify-section');
    if (!slot || !main || !gridSection || gridSection.parentElement !== main) return;

    const dock = dockQuery.matches && Boolean(slot.closest('.collection-grid--sidebar'));
    if (dock) {

      main.querySelectorAll(EXTRA_SECTIONS).forEach((section) => slot.appendChild(section));
    } else {

      let previous = gridSection;
      slot.querySelectorAll(EXTRA_SECTIONS).forEach((section) => {
        previous.after(section);
        previous = section;
      });
    }
  };

  if (dockQuery.addEventListener) dockQuery.addEventListener('change', syncDockedSections);
  else dockQuery.addListener?.(syncDockedSections);

  const boundSidebars = new WeakSet();
  const sidebarObserver =
    'ResizeObserver' in window
      ? new ResizeObserver((entries) => entries.forEach((entry) => entry.target.handleResize?.()))
      : null;

  const initSidebars = (scope = document) => {
    if (!sidebarObserver) return;
    scope.querySelectorAll('sticky-sidebar.collection-grid__filters').forEach((sidebar) => {
      if (boundSidebars.has(sidebar)) return;
      boundSidebars.add(sidebar);
      sidebarObserver.observe(sidebar);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const item = event.target instanceof Element ? event.target.closest('[data-hp-collection-slider] grid-carousel > *') : null;
      if (item) lastSliderClick = { key: sliderItemKey(item), time: performance.now() };
    },
    true,
  );

  document.addEventListener('collection:filter-change', (event) => {
    const section = event.target instanceof Element ? event.target.closest('collection-section') : null;
    if (section) setReplacing(section, true);
  });

  document.addEventListener('section:updating', (event) => {
    const section = event.target instanceof Element ? event.target.closest('collection-section') : null;
    if (section) saveSliderScroll(section);
  });

  const TURUNCU_SEGMENT_OTHER = 'diger';
  const TURUNCU_SEGMENT_VISIBLE_MAX = 5;

  const partitionTuruncuSegments = (section) => {
    const map = new Map();
    section.querySelectorAll('[data-hp-type-l2-slug]').forEach((el) => {
      const slug = el.getAttribute('data-hp-type-l2-slug') || TURUNCU_SEGMENT_OTHER;
      const label = el.getAttribute('data-hp-type-l2') || 'Diğer';
      if (!map.has(slug)) map.set(slug, label);
    });

    let other = null;
    if (map.has(TURUNCU_SEGMENT_OTHER)) {
      other = [TURUNCU_SEGMENT_OTHER, map.get(TURUNCU_SEGMENT_OTHER)];
      map.delete(TURUNCU_SEGMENT_OTHER);
    }

    const categories = [...map.entries()].sort((a, b) => a[1].localeCompare(b[1], 'tr'));
    return { categories, other };
  };

  const createTuruncuSegmentButton = (segmentSlug, label) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hp-chip';
    btn.dataset.hpTuruncuSegment = segmentSlug;
    btn.setAttribute('aria-pressed', 'false');
    btn.textContent = label;
    return btn;
  };

  const getTuruncuSegmentInsertAnchor = (scroller) =>
    scroller.querySelector('[data-hp-turuncu-segment-more-wrap]') ||
    scroller.querySelector('[data-hp-turuncu-segment-other]');

  const syncTuruncuSegmentUI = (section, slug) => {
    const nav = findTuruncuSegmentNav(section);
    if (!nav) return;

    const overflowRaw = nav.dataset.hpTuruncuOverflowSlugs || '';
    const overflowSlugs = overflowRaw ? overflowRaw.split('|') : [];
    const overflowActive = slug !== 'all' && overflowSlugs.includes(slug);

    nav.querySelectorAll('[data-hp-turuncu-segment]').forEach((btn) => {
      const isActive = (btn.dataset.hpTuruncuSegment || 'all') === slug;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const moreWrap = nav.querySelector('[data-hp-turuncu-segment-more-wrap]');
    moreWrap?.classList.toggle('is-active', overflowActive);

    const select = nav.querySelector('[data-hp-turuncu-segment-more-select]');
    if (select) select.value = overflowActive ? slug : '';

    const moreText = nav.querySelector('[data-hp-turuncu-segment-more-text]');
    if (moreText) {
      const defaultLabel = moreText.dataset.defaultLabel || moreText.textContent || '';
      if (overflowActive && select) {
        const option = [...select.options].find((entry) => entry.value === slug);
        moreText.textContent = option?.textContent?.trim() || defaultLabel;
      } else {
        moreText.textContent = defaultLabel;
      }
    }
  };

  const applyTuruncuSegmentFilter = (section) => {
    const state = getState(section);
    const slug = state.activeTuruncuSegment || 'all';
    let visibleCount = 0;

    section.querySelectorAll('[data-hp-type-l2-slug]').forEach((el) => {
      const li = el.closest('li');
      if (!li) return;
      const cardSlug = el.getAttribute('data-hp-type-l2-slug') || TURUNCU_SEGMENT_OTHER;
      const show = slug === 'all' || cardSlug === slug;
      li.classList.toggle('hp-turuncu-segment-hidden', !show);
      if (show) visibleCount += 1;
    });

    const emptyEl = findTuruncuSegmentNav(section)?.querySelector('[data-hp-turuncu-segment-empty]');
    if (emptyEl) emptyEl.hidden = slug === 'all' || visibleCount > 0;
  };

  const findTuruncuSegmentNav = (section) => {
    const inSection = section.querySelector('[data-hp-turuncu-segment-nav]');
    if (inSection) return inSection;
    const main = section.closest('.hp-collection-main');
    return main?.querySelector('[data-hp-turuncu-segment-nav]') ?? null;
  };

  const rebuildTuruncuSegmentPills = (section) => {
    const nav = findTuruncuSegmentNav(section);
    if (!nav) return;
    const scroller = nav.querySelector('[data-hp-turuncu-segment-scroller]');
    if (!scroller) return;

    scroller
      .querySelectorAll(
        '[data-hp-turuncu-segment]:not([data-hp-turuncu-segment="all"]):not([data-hp-turuncu-segment-other])',
      )
      .forEach((btn) => btn.remove());

    const { categories, other } = partitionTuruncuSegments(section);
    const otherBtn = scroller.querySelector('[data-hp-turuncu-segment-other]');
    nav.hidden = false;

    if (categories.length === 0 && !other) {
      nav.dataset.hpTuruncuOverflowSlugs = '';
      const moreWrap = scroller.querySelector('[data-hp-turuncu-segment-more-wrap]');
      if (moreWrap) moreWrap.hidden = true;
      if (otherBtn) otherBtn.hidden = true;
      syncTuruncuSegmentUI(section, getState(section).activeTuruncuSegment || 'all');
      return;
    }

    const visibleCategories = categories.slice(0, TURUNCU_SEGMENT_VISIBLE_MAX);
    const overflowCategories = categories.slice(TURUNCU_SEGMENT_VISIBLE_MAX);

    const insertAnchor = getTuruncuSegmentInsertAnchor(scroller);
    visibleCategories.forEach(([segmentSlug, label]) => {
      const btn = createTuruncuSegmentButton(segmentSlug, label);
      if (insertAnchor) scroller.insertBefore(btn, insertAnchor);
      else scroller.appendChild(btn);
    });

    nav.dataset.hpTuruncuOverflowSlugs = overflowCategories.map(([segmentSlug]) => segmentSlug).join('|');

    const moreWrap = scroller.querySelector('[data-hp-turuncu-segment-more-wrap]');
    const select = nav.querySelector('[data-hp-turuncu-segment-more-select]');
    const moreText = nav.querySelector('[data-hp-turuncu-segment-more-text]');
    const moreDefaultLabel = moreText?.dataset.defaultLabel || '';

    if (moreWrap && select) {
      if (overflowCategories.length === 0) {
        moreWrap.hidden = true;
        select.replaceChildren();
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = moreDefaultLabel;
        select.appendChild(placeholder);
      } else {
        moreWrap.hidden = false;
        select.replaceChildren();
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = moreDefaultLabel;
        select.appendChild(placeholder);
        overflowCategories.forEach(([segmentSlug, label]) => {
          const option = document.createElement('option');
          option.value = segmentSlug;
          option.textContent = label;
          select.appendChild(option);
        });
      }
    }

    if (otherBtn) {
      if (other) {
        otherBtn.hidden = false;
        otherBtn.textContent = other[1];
      } else {
        otherBtn.hidden = true;
      }
    }

    const state = getState(section);
    const allSlugs = [
      ...categories.map(([segmentSlug]) => segmentSlug),
      ...(other ? [other[0]] : []),
    ];
    let active = state.activeTuruncuSegment || 'all';
    if (active !== 'all' && !allSlugs.includes(active)) active = 'all';
    state.activeTuruncuSegment = active;
    syncTuruncuSegmentUI(section, active);
    applyTuruncuSegmentFilter(section);
  };

  const initTuruncuSegmentFilter = (section) => {
    if (!section.hasAttribute('data-hp-turuncu-segment-filter')) return;

    const state = getState(section);
    if (state.activeTuruncuSegment == null) state.activeTuruncuSegment = 'all';

    if (!state.turuncuSegmentClickBound) {
      state.turuncuSegmentClickBound = true;
      section.addEventListener('click', (event) => {
        const btn = event.target instanceof Element ? event.target.closest('[data-hp-turuncu-segment]') : null;
        if (!btn) return;
        const navRoot = findTuruncuSegmentNav(section);
        if (!navRoot?.contains(btn)) return;
        state.activeTuruncuSegment = btn.dataset.hpTuruncuSegment || 'all';
        syncTuruncuSegmentUI(section, state.activeTuruncuSegment);
        applyTuruncuSegmentFilter(section);
      });
      section.addEventListener('change', (event) => {
        const select =
          event.target instanceof Element ? event.target.closest('[data-hp-turuncu-segment-more-select]') : null;
        if (!select) return;
        const navRoot = findTuruncuSegmentNav(section);
        if (!navRoot?.contains(select)) return;
        const slug = select.value;
        if (!slug) return;
        state.activeTuruncuSegment = slug;
        syncTuruncuSegmentUI(section, slug);
        applyTuruncuSegmentFilter(section);
      });
    }

    rebuildTuruncuSegmentPills(section);
  };

  const refreshSection = (section) => {
    initSliders(section);
    initScrollRows(section);
    initSidebars(section);
    observeLoadMore(section);
    reapplyFilterSearch();
    initTuruncuSegmentFilter(section);
    getState(section).below = readBelowList(section);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const loadMore = target.closest('[data-hp-load-more]');
    if (loadMore) {
      const section = loadMore.closest('collection-section');
      if (!section) return;
      event.preventDefault();
      requestNextPage(section, loadMore);
      return;
    }

    const pageLink = target.closest('[data-hp-page-link]');
    if (pageLink) {
      const section = pageLink.closest('collection-section');
      if (!section) return;
      event.preventDefault();

      const state = getState(section);
      if (state.restoring) return;
      state.pageJump = true;
      setReplacing(section, true);
      pageLink.dispatchEvent(
        new CustomEvent('section:update', {
          bubbles: true,
          detail: { url: pageLink.href, mode: 'replace', scrollToTop: true },
        }),
      );
    }
  });

  document.addEventListener('section:content-updated', (event) => {
    const section = event.target instanceof Element ? event.target.closest('collection-section') || event.target : null;
    if (!section || section.tagName !== 'COLLECTION-SECTION') return;

    const state = getState(section);
    const mode = event.detail?.mode;

    if (mode === 'append') {

      if (state.lastRequestedPage) {
        window.history.replaceState(window.history.state, '', buildPageUrl(state.lastRequestedPage).toString());
      }
      state.lastRequestedPage = null;
      setLoading(section, null);
      holdBelowList(section, state.below);

      setScrollRestoration('manual');
    } else if (mode === 'replace') {

      state.autoLoaded = 0;
      state.lastRequestedPage = null;
      setReplacing(section, false);
      disconnectObserver(state);
      setLoading(section, null);
      setScrollRestoration('auto');

      const currentPage = getPageFromUrl(window.location.href);
      const normalizedUrl = buildPageUrl(currentPage).toString();
      if (normalizedUrl !== window.location.href) window.history.replaceState(window.history.state, '', normalizedUrl);

      if (currentPage === 1 && hasDeferredSections()) loadFirstPageSections();

      if (state.pageJump) {
        state.pageJump = false;
        waitForInput(section);
      }
    } else if (mode === 'prepend') {
      setScrollRestoration('manual');

      waitForInput(section);
    }

    refreshSection(section);
    restoreSliderScroll(section);
  });

  document.addEventListener('section:error', (event) => {
    const section = event.target instanceof Element ? event.target.closest('collection-section') : null;
    if (!section) return;

    const state = getState(section);
    state.sliderScroll = null;
    state.lastRequestedPage = null;
    state.pageJump = false;
    setReplacing(section, false);
    clearLoadMoreBusy(section);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initSliders(event.target);
    initScrollRows(event.target);
    event.target.querySelectorAll?.('collection-section').forEach(refreshSection);
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.name === 'AbortError') event.preventDefault();
  });

  const start = () => {

    syncDockedSections();
    initSliders(document);

    initScrollRows(document);
    initSidebars(document);

    const sectionsReady = shouldRestoreSections() ? loadFirstPageSections() : null;

    document.querySelectorAll('collection-section').forEach((section) => {

      restoreList(section, sectionsReady)
        .catch(() => false)
        .then((restored) => {
          if (restored) {

            section.dispatchEvent(new CustomEvent('section:content-updated', { bubbles: true, detail: { mode: 'prepend' } }));
          } else {
            refreshSection(section);
          }
        });
    });

    wait(600).then(() => initSliders(document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.HpCollectionPage = { initSliders };
})();
